import { useState } from 'react';
import { cn } from '@/utils';

export default function FormatSwitch() {
  const [isMP3, setIsMP3] = useState(true);

  return (
    <div className="min-h-[60px] w-full grid place-items-center ">
      <div className="flex flex-col items-center gap-2">
        <div className="text-gray-400 text-[10px] font-mono">QUALITY</div>

        <div
          onClick={() => setIsMP3(!isMP3)}
          className="relative w-[80px] h-[40px] rounded-full transition-colors duration-200 overflow-hidden group"
          style={{
            background: 'linear-gradient(to bottom, #333333, #262626)',
            boxShadow:
              '0 4px 12px rgba(0,0,0,0.5), inset 0 -2px 3px rgba(255,255,255,0.2)',
          }}
        >
          <div
            className={cn(
              'absolute w-[45px] h-[32px] top-[4px] rounded-full transition-all duration-300 ease-in-out',
              'bg-gradient-to-b from-jen-black-40 to-jen-black-100',
              // 'shadow-[inset_0_2px_4px_rgba(255,255,255,0.2),_0_2px_8px_rgba(0,0,0,0.4)]',
              // "after:content-[''] after:absolute after:top-0 after:left-0 after:right-0 after:bottom-0 after:rounded-full after:opacity-0 after:transition-opacity after:duration-300",
              // 'after:bg-[radial-gradient(circle,rgba(255,255,255,0.3)_0%,transparent_70%)]',
              'group-hover:after:opacity-100',
              isMP3 ? 'left-[30px] scale-105' : 'left-[5px]',
            )}
          />
          <div
            className={cn(
              'absolute inset-0 bg-blue-400 opacity-0 transition-opacity duration-300 rounded-full',
              isMP3 ? 'animate-glow' : '',
            )}
          />
        </div>

        <div className="flex justify-between w-[120px] px-4">
          <span
            className={cn(
              'text-white font-mono text-[10px] font-bold transition-all duration-300',
              !isMP3 ? 'text-jen-orange' : '',
            )}
          >
            WAV
          </span>
          <span
            className={cn(
              'text-white font-mono text-[10px] font-bold transition-all duration-300',
              isMP3 ? 'text-jen-orange' : '',
            )}
          >
            MP3
          </span>
        </div>
      </div>
    </div>
  );
}
